// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3n68D","large":"styles_large___Tvjw"};